import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import cx from "classnames";
import { FormattedMessage } from 'react-intl';
//import PerfectScrollbar from "perfect-scrollbar";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";

// @material-ui/icons
import AlternateEmail from "@material-ui/icons/AlternateEmail";

// custom components
import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";
import SidebarLoading from 'components/common/loading/SidebarLoading';
import SidebarMenus from './SidebarMenus';
import { setSelectedSidebarItem, setSidebarItems, toggleSidebar } from 'store/actions/sidebarActions'
import { getTopMenu } from "util/common";
import { 
    COLOR_SYSTEM
} from 'util/constants';


/**
 * material-dashboard-pro-react-v1.5.0 > Sidebar.jsx 참고
 */
//var ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends Component {
    componentDidMount() {
        // if (navigator.platform.indexOf("Win") > -1) {
        //     ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        //         suppressScrollX: true,
        //         suppressScrollY: false
        //     });
        // }
    }

    componentWillUnmount() {
        // if (navigator.platform.indexOf("Win") > -1) {
        //     ps.destroy();
        // }
    }

    render() {
        const { className, links, isSmallScreen } = this.props;
        return (
            <div className={className} ref="sidebarWrapper">
                {React.cloneElement(links, {
                    isSmallScreen
                })}
            </div>
        );
    }
}


class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSidebarOpen: false // onMouseOver/onMouseOut 시 사이드바 open/close 상태
        };
    }

    componentDidMount() {
        if( this.props.isCompanyAdmin !== undefined ) {
            this.props.dispatchSetSidebarItems(
                this.props.topMenu, 
                this.props.match.params.subMenu, 
                this.props.isApplicationAdmin, 
                this.props.isCompanyAdmin);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) { //componentWillReceiveProps has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.
        if( nextProps.isCompanyAdmin !== this.props.isCompanyAdmin 
            || nextProps.isApplicationAdmin !== this.props.isApplicationAdmin  ) {
            this.props.dispatchSetSidebarItems(
                nextProps.topMenu, 
                nextProps.match.params.subMenu, 
                nextProps.isApplicationAdmin, 
                nextProps.isCompanyAdmin);
        }

        if( nextProps.match.params.subMenu !== this.props.match.params.subMenu ) {
            this.props.dispatchSetSelectedSidebarItem(nextProps.match.params.subMenu);
        }
    }

    // 리렌더링이 불필요한 케이스 정의 
    // shouldComponentUpdate(nextProps, nextState){
    //     if (
    //         nextProps.sidebarItems === this.props.sidebarItems &&
    //         nextProps.isSidebarOpen === this.props.isSidebarOpen &&
    //         nextProps.isMobileSidebarOpen === this.props.isMobileSidebarOpen &&
    //         nextProps.selectedSidebarItem === this.props.selectedSidebarItem &&
    //         nextProps.isApplicationAdmin === this.props.isApplicationAdmin &&
    //         nextProps.isCompanyAdmin === this.props.isCompanyAdmin &&
    //         nextState === this.state
    //     ) {
    //         return false;
    //     }
    //     return true;
    // }

    setSidebarOpen = (isOpen) => (event) => {
        this.setState({ isSidebarOpen: isOpen });
    }

    render() {
        console.log("Sidebar >>>> render");
        const {
            classes,
            color,
            topMenu,
            image,
            isMobileSidebarOpen,
            bgColor,
            sidebarItems, mailUsage, isLoading
          } = this.props;
        const matchUrl = this.props.match.url;
        
        const isSidebarOpen = isMobileSidebarOpen || this.props.isSidebarOpen || this.state.isSidebarOpen;
        console.log("Sidebar >>>> render, isSidebarOpen:",isSidebarOpen);

        // css
        const drawerPaper =
            classes.drawerPaper +
            " " + (isSidebarOpen ? "" : classes.drawerPaperMini);
        const sidebarWrapper = cx(classes.sidebarWrapper, {
            "sidebarWrapper-fix": true,
            [classes.drawerPaperMini]: !isSidebarOpen
            //[classes.sidebarWrapperWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1
        });

        // 구역별 정보 
        const brand = (
            <div className={classes.logo + " " + (bgColor === "white" ? classes.whiteAfter : "")}>
                <div className={classes.logoMini}>
                    <AlternateEmail className={classes.img} />
                    {/* <img src={logo} alt="logo" className={classes.img} /> */}
                </div>
                <div className={classes.logoNormal + " " + (isSidebarOpen ? "" : classes.logoNormalSidebarMini)}>
                    <FormattedMessage id="product.name" />
                </div>
            </div>
        );

        const links = <SidebarMenus 
                            isSidebarOpen={isSidebarOpen}
                            sidebarItems={sidebarItems} 
                            matchUrl={matchUrl}
                            color={color}
                            badgeColor={COLOR_SYSTEM }
                            topMenu={topMenu}
                            mailUsage={mailUsage}
                        />;

        return (
            <div ref="mainPanel">
                {/* 화면이 작을 때 보이는 메뉴&타이틀 (xs/sm사이즈에서만 보임, md/lg/xl사이즈에서 안보임) */}
                <Hidden mdUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor="right"
                        open={isMobileSidebarOpen}
                        classes={{
                            paper: drawerPaper + " " + classes[bgColor + "Background"]
                        }}
                        onClose={this.props.onToggleMobileSidebar}
                    >
                        <Fragment>
                            { isLoading && <SidebarLoading />}
                            { isLoading || (
                                <Fragment>
                                    {brand}
                                    <SidebarWrapper
                                        className={sidebarWrapper}
                                        links={links}
                                        isSmallScreen={true}
                                    />
                                    {image !== undefined ? (
                                        <div
                                            className={classes.background}
                                            style={{ backgroundImage: "url(" + image + ")" }}
                                        />
                                    ) : null}
                                </Fragment>
                            )}
                        </Fragment>
                    </Drawer>
                </Hidden>

                {/* 화면이 클 때 보이는 메뉴&타이틀 (xs/sm사이즈에서 hidden, md/lg/xl사이즈에서만 보임) */}
                <Hidden smDown implementation="css">
                    <Drawer
                        onMouseOver={this.setSidebarOpen(true)}
                        onMouseOut={this.setSidebarOpen(false)}
                        anchor="left"
                        variant="permanent"
                        open
                        classes={{
                            paper: drawerPaper + " " + classes[bgColor + "Background"]
                        }}
                    >
                        <Fragment>
                            { isLoading && <SidebarLoading />}
                            { isLoading || (
                                <Fragment>
                                    {brand}
                                    <SidebarWrapper
                                        className={sidebarWrapper}
                                        links={links}
                                        isSmallScreen={false}
                                    />
                                    {image !== undefined ? (
                                        <div
                                            className={classes.background}
                                            style={{ backgroundImage: "url(" + image + ")" }}
                                        />
                                    ) : null}
                                </Fragment>
                            )}
                        </Fragment>
                    </Drawer>
                </Hidden>
            </div>
        )

    }
}

Sidebar.defaultProps = {
    bgColor: "black",//"blue",
    color: "white",//"white",
    isSidebarOpen: false,
};

Sidebar.propTypes = {
    classes: PropTypes.object.isRequired,
    bgColor: PropTypes.oneOf(["white", "black", "blue"]),
    color: PropTypes.oneOf([
        "white",
        "red",
        "orange",
        "green",
        "blue",
        "purple",
        "rose"
    ]),
    //logo: PropTypes.string,
    //logoText: PropTypes.string,
    image: PropTypes.string,
    isMobileSidebarOpen: PropTypes.bool.isRequired,
    onToggleMobileSidebar: PropTypes.func.isRequired
};

export default compose(
    withStyles(sidebarStyle),
    withRouter,
    connect(
        ( state, props ) => ({
            topMenu: getTopMenu(props),
            sidebarItems: state.sidebar.sidebarItems,
            isApplicationAdmin: false,
            isCompanyAdmin: false,
            isSidebarOpen: state.sidebar.sidebarOpen,
            isLoading: state.sidebar.loadingVersion > 0,
            selectedSidebarItem: state.sidebar.selectedSidebarItem
        }), {
            dispatchSetSelectedSidebarItem: setSelectedSidebarItem,
            dispatchSetSidebarItems: setSidebarItems,
            dispatchToggleSidebar: toggleSidebar
        }
    ),
)(Sidebar);
